import React, { useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import './App.css';
import NavigationMenu, { MenuKeys } from './ui/navigationMenu/NavigationMenu';
import IntentForm from './ui/editor/intentManager/IntentManager';
import EntityManager from './ui/editor/entityManager/EntityManager';
import FlowManager from './ui/editor/flowManager/flowManager';
import PageHeader from './ui/pageHeader/PageHeader';
import { exploreBotAction } from './business/actions/botActions';
import TtsManager from './ui/editor/ttsManager/TtsManager';

interface AppProps extends RouteComponentProps {
}

export const App: React.FunctionComponent<AppProps> = (props) => {
  const [selectedMenu, setSelectedMenu] = useState(MenuKeys.tts)
  
  const Content = () => {
    switch (selectedMenu) {
      case MenuKeys.flows:
        return <FlowManager />
      case MenuKeys.intents:
        return <IntentForm />
      case MenuKeys.entities:
        return <EntityManager />
      case MenuKeys.tts:
          return <TtsManager />
      default:
        return null;
    }
  }

  const renderAppLoginContent = () => {
    return <div className="App">
      <NavigationMenu onSelect={(key: string) => { setSelectedMenu(key as MenuKeys) }} />
      <div style={{ width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <PageHeader
          style={{
            borderStyle: 'solid',
            padding: '10px 24px 10px 70px',
            borderWidth: '0px 0px 1px 0px',
            borderColor: '#ececec'
          }}
          showBotSelector={true}
          onBotSelect={exploreBotAction.request}
          onBackDestination='/'
          title='Builder'
          subTitle='Configurez votre agent conversationnel'
        />
        <div style={{width: '100%', height: 'calc(100% - 53.3px)'}}>
        <Content />
        </div>
      </div>
    </div>
  }

  const renderApp = () => {
    return renderAppLoginContent();
  }

  return renderApp();
}

export default App;
